import {
  CookbookMealConnectorApollo,
  TrackerAddMealConnectorApollo,
  SaveAsUserMealConnectorApollo,
  useAppContext,
} from '@front-activerse/common-components';
import { useParams } from 'react-router-dom';
import TrackerAddMealContainer from './TrackerAddCookbookMealContainer';

const TrackerIndexPage = () => {
  const { dietMealId } = useParams();
  const { post } = useAppContext();

  if (!dietMealId) {
    return <div>Missing parameters</div>;
  }

  return (
    <CookbookMealConnectorApollo mealId={+dietMealId}>
      {(cookbookMealData: any) => (
        <TrackerAddMealConnectorApollo post={post}>
          {({ addMeal }: { addMeal: (input: any, saveYourMeal: boolean) => Promise<any> }) => (
            <SaveAsUserMealConnectorApollo post={post}>
              {({ saveAsUserMeal }: { saveAsUserMeal: (input: any) => Promise<any> }) => (
                <TrackerAddMealContainer
                  {...cookbookMealData.meal}
                  loading={cookbookMealData.loading}
                  addMeal={addMeal}
                  saveAsUserMeal={saveAsUserMeal}
                  key={dietMealId}
                />
              )}
            </SaveAsUserMealConnectorApollo>
          )}
        </TrackerAddMealConnectorApollo>
      )}
    </CookbookMealConnectorApollo>
  );
};

export default TrackerIndexPage;
